/**
 * Analytics Event Names
 *
 * Centralized enum for all analytics event names used throughout the application.
 * This ensures type safety and consistency across all analytics tracking calls.
 */

export enum AnalyticsEvent {
    // Page tracking
    PAGE_VIEWED = 'Page Viewed',

    // User authentication & onboarding
    SIGNUP = 'Signup',
    SIGNUP_SEGMENT = 'User Signed Up',
    PHONE_VERIFICATION_SUCCESSFUL = 'Phone Verification Successful',
    EMAIL_VERIFICATION_SUCCESSFUL = 'Email Verification Successful',
    PREFILL_EMAIL_CONFIRMED = 'Prefill Email Confirmed',
    VERIFICATION_SUCCESSFUL = 'Verification Successful',
    TRIAL_STARTED = 'Trial Started',

    // KYC & Prefill
    KYC_PREFILL_SSN_COMPLETED = 'KYC Prefill SSN Completed',

    // Early Pay / Subscription Flow
    LINKED_ACCOUNT_ADDED = 'Linked Account Added',
    EARLYPAY_BANK_CONNECTION = 'Earlypay Bank Connection',
    EARLYPAY_APPLICATION_SUBMITTED = 'Earlypay Application Submitted',
    EARLYPAY_USER_VERIFIED = 'Earlypay User Verified',
    EARLYPAY_CONFIRM_SUBSCRIPTION = 'Earlypay Confirm Subscription',
    EARLYPAY_SUBSCRIPTION_SUCCESS = 'Earlypay Subscription Success',
    EARLYPAY_SUBSCRIPTION_ERROR = 'Subscription error',

    // KYC Results
    KYC_ATTEMPT = 'KYC Attempt',
    KYC_SUCCESS = 'KYC Success',
    EARLYPAY_KYC_INVALID = 'Earlypay KYC Invalid',
    EARLYPAY_KYC_ERROR = 'Earlypay KYC Error',
    EARLYPAY_KYC_EXCEPTION = 'Earlypay KYC Exception',

    // Underwriting
    EARLYPAY_UNDERWRITING_ERROR = 'EarlyPay Underwriting Error',
    EARLYPAY_UNDERWRITING_APPROVED = 'EarlyPay Underwriting Approved',
    EARLYPAY_UNDERWRITING_PENDING = 'EarlyPay Underwriting Pending',
    EARLYPAY_UNDERWRITING_REJECTED = 'EarlyPay Underwriting Rejected',
}
